import { Component, OnInit, Renderer2 } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { QuestionnaireService } from '../../../../services/questionnaire.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorDialogComponent } from '../../../user-actions/error-dialog/error-dialog.component';
import { MatRadioButton } from '@angular/material/radio';
import { Q_LARS, LARSResults } from '../../../../model/questionnaires/questionnaire-lars';

@Component({
  selector: 'app-questionnaire-lars',
  templateUrl: './questionnaire-lars.component.html',
  styleUrls: ['./questionnaire-lars.component.css']
})
export class QuestionnaireLarsComponent implements OnInit {

  qForm: FormGroup;
  notFocused = false;
  source = Q_LARS;
  results = [];
  submitted = false;
  show = false;
  currentCheckedValue = [null];
  found = false;

  /// toolbar
  back = true;
  destination = '/questionnaires';
  title = 'LARS';
  user = null;
  uuid = null;
  authorization: boolean;
  doctorID: string;
  patientSSN: string;

  constructor(private questionnaireService: QuestionnaireService,
    private ren: Renderer2,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit(): void {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.source.length; ++i) {
      this.results.push(null);
    }

    this.user = JSON.parse(localStorage.getItem('user'));
    this.route.params.subscribe(params => {
      this.doctorID = params.doctorID;
      this.patientSSN = params.patientSSN;
      this.uuid = params.uuid;
      this.authorization = this.user.ssn.localeCompare(params.patientSSN) === 0;
      if (params.back.localeCompare('questionnaires') === 0) {
        this.destination = 'questionnaires';
      } else if (params.back.localeCompare('choose-questionnaire') === 0) {
        this.destination = 'choose-questionnaire';
      }
    });
  }

  openDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
    });
  }

  setAnswer(button: MatRadioButton, answer: string, position: number) {
    this.results[position - 1] = answer;
    console.log(this.results);
  }

  checkState(el, position: number) {
    setTimeout(() => {
      if (this.currentCheckedValue[position - 1] && this.currentCheckedValue[position - 1] === el.value) {
        el.checked = false;
        this.ren.removeClass(el._elementRef.nativeElement, 'cdk-focused');
        this.ren.removeClass(el._elementRef.nativeElement, 'cdk-program-focused');
        this.currentCheckedValue[position - 1] = null;
        this.results[position - 1] = null;
      } else {
        this.currentCheckedValue[position - 1] = el.value;
      }
    });
  }

  onSubmit() {
    this.submitted = true;
    this.show = true;
    this.found = false;

    console.log(this.results);
    if (this.results.length !== this.source.length) {
      const msg = 'Non hai finito di completare il questionario!';
      this.openDialog(msg);
      this.show = false;
      this.submitted = false;
    } else {
      for (const r of this.results) {
        if (r === null) {
          const msg = 'Non hai finito di completare il questionario!';
          this.openDialog(msg);
          this.show = false;
          this.submitted = false;
          this.found = true;
          break;
        }
      }

      if (!this.found) {
        let finalScore = 0;
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < this.results.length; ++i) {
          finalScore += parseInt(this.results[i].split('-')[0][0], 10);
        }
        const resultToSend = new LARSResults(this.doctorID, this.patientSSN, this.results, finalScore);
        this.questionnaireService.sendForm(resultToSend, 'lars', this.uuid);
      }
    }
  }
  goHome() {
    if (this.user === null) {
      this.router.navigateByUrl('/startup');
    } else {
      this.router.navigateByUrl('/landing');
    }
  }
}
